import { Card, Empty, message, Skeleton, Tabs } from "antd";
import React from "react";
import { useParams } from "react-router-dom";
import { ChannelType } from "../../contexts/channels/ChannelProvider";
import {
  PaymentContext,
  PaymentContextProvider,
  PaymentContextType,
} from "../../contexts/payment/PaymentContext";
import { thousandSeparator } from "../../helpers/thousand_separator";
import { ChannelModel } from "../../models/ChannelModel";
import "./payment.css";
import { DonationSingleResultInterface } from "../../contexts/payment/interfaces/donation-single-result.interface";
import axios from "axios";
import { CompanySingleResultInterface } from "../../models/CompanyModel";
import {
  BCAVANicepay,
  BNIVANicepay,
  BRIVANicepay,
  MANDIRIVANicepay,
} from "../../contexts/channels/interfaces/midtrans-channel";

function PaymentNicepayV2() {
  return (
    <PaymentContextProvider>
      <PaymentState />
    </PaymentContextProvider>
  );
}

function PaymentState() {
  const [channel, setChannel] = React.useState<ChannelModel>();
  const {
    paymentResultNicepay,
    doPaymentNicepay,
    loading,
    initPayment,
    // transactionStatusModel,
    checkStatusNicepay,
    getDonationDetail,
    donationDetail,
    getDonationDetailForStatus,
    donationDetailForStatus,
  } = React.useContext(PaymentContext) as PaymentContextType;
  const [vaNumber, setVaNumber] = React.useState<string | undefined>(
    "123456789"
  );
  const [bankCode, setBankCode] = React.useState<string>();
  const [donationResult, setDonationResult] =
    React.useState<DonationSingleResultInterface>(undefined);
  const params = useParams();

  React.useEffect(() => {
    console.log(params);
    if (params) {
      if (params["invoice_code"] !== undefined) {
        getDonationDetail(params["invoice_code"] as string);

        // get donation status every 5 seconds
        const interval = setInterval(() => {
          checkStatusNicepay();
          getDonationDetailForStatus(params["invoice_code"] as string);
        }, 5000);
        // Stop the interval when the component unmounts
        return () => clearInterval(interval);
      }
    }
  }, []);

  React.useEffect(() => {
    if (donationDetail !== undefined) {
      switch (donationDetail?.data?.payment_name?.toLowerCase()) {
        case "bca virtual account":
          setChannel({
            id: donationDetail?.data?.payment_id,
            ...BCAVANicepay,
          });
          break;
        case "mandiri virtual account":
          setChannel({
            id: donationDetail?.data?.payment_id,
            ...MANDIRIVANicepay,
          });
          break;
        // case "qris":
        //   setChannel({
        //     id: donationDetail?.data?.payment_id,
        //     ...QRISNicepay,
        //   });
        //   break;
        // case "alfamart":
        //   setChannel({
        //     id: donationDetail?.data?.payment_id,
        //     ...ALFAMARTNicepay,
        //   });
        //   break;
        // case "indomaret":
        //   setChannel({
        //     id: donationDetail?.data?.payment_id,
        //     ...INDOMARETNicepay,
        //   });
        //   break;
        case "bni virtual account":
          setChannel({
            id: donationDetail?.data?.payment_id,
            ...BNIVANicepay,
          });
          break;
        case "bri virtual account":
          setChannel({
            id: donationDetail?.data?.payment_id,
            ...BRIVANicepay,
          });
          break;
      }
      setDonationResult(donationDetail);
    }
    console.log(channel);
  }, [donationDetail]);

  React.useEffect(() => {
    if (donationDetailForStatus !== undefined) {
      if (
        donationDetailForStatus?.data?.status === "settlement" ||
        donationDetailForStatus?.data?.status === "capture"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            console.log(response);
            const url = `${response?.data?.platform_donation}/payment/success?order_id=${donationDetailForStatus?.data?.order_id}&result=success`;
            window.location.href = url;
          });
      } else if (
        donationDetailForStatus?.data?.status === "cancel" ||
        donationDetailForStatus?.data?.status === "deny"
      ) {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/failed?order_id=${donationDetailForStatus?.data?.order_id}&result=failed`;
            window.location.href = url;
          });
      } else if (donationDetailForStatus?.data?.status === "expire") {
        axios
          .get(
            `${process.env.REACT_APP_MAIN_URL}/public/companies/${process.env.REACT_APP_COMPANY_ID}`
          )
          .then((res) => {
            const response = res.data as CompanySingleResultInterface;
            const url = `${response?.data?.platform_donation}/payment/timeout?order_id=${donationDetailForStatus?.data?.order_id}&result=expire`;
            window.location.href = url;
          });
      }
    }
  }, [donationDetailForStatus]);

  React.useEffect(() => {
    if (channel) {
      // doPayment(channel, encrypt);
      // setVaNumber(channel.account_number);
      if (channel.type !== ChannelType.EWALLET) {
        if (channel.additional_text) {
          if (channel.additional_text.length > 0) {
            setBankCode(channel.additional_text[0]);
          }
        }
      }
    }
  }, [channel]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (donationResult !== undefined && channel !== undefined) {
      doPaymentNicepay(channel);
      initPayment(donationResult?.data?.id, channel?.id, "");
    }
  }, [donationResult, channel]);

  React.useEffect(() => {
    if (paymentResultNicepay?.status) {
      setVaNumber(paymentResultNicepay?.data?.vacctNo);
      //   setQrCode(paymentResultNicepay?.data?.Data?.QrImage);
    }
  }, [paymentResultNicepay]);

  return (
    <div
      style={{
        margin: 20,
      }}
    >
      <Skeleton loading={loading}>
        <h1>{channel?.title}</h1>
        <h2>{channel?.subtitle}</h2>
        {paymentResultNicepay?.status === true ? (
          <>
            <Card
              hoverable
              style={{
                marginBottom: 10,
              }}
            >
              <p className="amount">Jumlah</p>
              <div
                style={{
                  float: "right",
                }}
              >
                <span className="amount-rp">Rp </span>
                <span className="amount-number">
                  {thousandSeparator(donationResult?.data?.amount)}
                </span>
              </div>
            </Card>
            {channel?.type === ChannelType.EWALLET && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                  textAlign: "center",
                }}
              >
                <span className="account-number-text">
                  {channel.additional_text ? channel.additional_text[0] : ""}
                </span>
                <br />
                {/* {qrCode !== undefined ? (
                  <div>
                    <QRCode
                      value={paymentResultNicepay?.data?.Data?.QrString}
                    />
                    <Divider />
                    <img
                      src="/assets/qris-bpd-bali.png"
                      style={{ width: "13em" }}
                      alt="QRIS Nicepay"
                    />
                    <br />
                    <img
                      src="/assets/scan_qris.png"
                      style={{ width: "15em" }}
                      alt="QRIS Nicepay"
                    />
                  </div>
                ) : null} */}
                {/* {deeplink !== undefined && (
                  <a
                    className="deeplink"
                    target={"_blank"}
                    rel="noreferrer"
                    href={deeplink}
                  >
                    {channel.additional_text
                      ? channel.additional_text[1]
                      : "Error"}
                  </a>
                )} */}
              </Card>
            )}
            {bankCode && (
              <Card
                hoverable
                style={{
                  marginBottom: 10,
                }}
              >
                <p className="amount">Kode Bank</p>
                <div
                  style={{
                    float: "right",
                  }}
                >
                  <span className="amount-number">{bankCode}</span>
                </div>
              </Card>
            )}
            {channel?.type !== ChannelType.EWALLET ? (
              <Card
                style={{
                  marginBottom: 10,
                }}
              >
                {vaNumber && (
                  <div style={{ float: "left" }}>
                    <span className="account-number-text-block">
                      Nomor Rekening
                    </span>
                    <span className="account-number">{vaNumber}</span>
                    <br />
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        message.info(`Nomor Rekening berhasil di salin.`);
                        navigator.clipboard.writeText(vaNumber);
                      }}
                    >
                      Salin Nomor Rekening
                    </a>
                  </div>
                )}
              </Card>
            ) : (
              <div></div>
            )}
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={paymentResultNicepay?.data?.resultMsg}
          />
        )}
      </Skeleton>

      <Card hoverable title={"Detail Transaksi"} style={{ marginBottom: 10 }}>
        <span className="transaction-detail-text">Nama Program</span>
        <span className="transaction-detail-description">
          {donationResult?.data?.program_name}
        </span>
      </Card>

      {channel?.hows?.length > 0 ? (
        <Card hoverable title={"Cara Pembayaran"} style={{ marginBottom: 10 }}>
          <Tabs>
            {channel?.hows?.map((item, index) => (
              <Tabs.TabPane tab={item.name} key={index}>
                {item.steps?.map((item, index) => (
                  <p key={index}>
                    {index + 1}. {item}
                  </p>
                ))}
              </Tabs.TabPane>
            ))}
          </Tabs>
        </Card>
      ) : (
        <></>
      )}
    </div>
  );
}

export default PaymentNicepayV2;
